import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { Container } from './ui/Container';
import { CheckItem } from './ui/CheckItem';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
const sinKit = ['Tienes 250 páginas sin un mapa de uso', 'Cada semana decides qué toca', 'Buscas en el PDF entre páginas', 'Avanzas por intuición', 'El manual se usa al 70%'];
const conKit = ['Tienes 250 páginas con un calendario', 'Cada semana confirmas lo que ya está decidido', 'Encuentras el esquema en 10 segundos', 'Avanzas con criterio real', 'El manual se usa al 100%'];
export function KitComparison() {
  return <section className="bg-mp-black py-20 md:py-24" data-id="element-216" data-mp="6r6pyjuhfr2b">
      <Container data-id="element-217" data-mp="6sqbaouzwsay">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6" data-id="element-218" data-mp="6p2g7l9wjxu4">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: easeOut
        }} className="rounded-2xl border border-mp-border bg-mp-dark p-7 md:p-9" data-id="element-219" data-mp="1d6zerslpzsvh">
            <p className="font-heading text-lg uppercase tracking-wide text-mp-gray sm:text-xl" data-id="element-220" data-mp="19kl915d7jw0o">Sin el Kit</p>
            <ul className="mt-6 space-y-3" data-id="element-221" data-mp="zo9vyd5sn256">
              {sinKit.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-222" data-mp="zqclyx6y4v9w">
                  <XIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-mp-gray/60" strokeWidth={2.5} data-id="element-223" data-mp="vng4j9t5757j" />
                  <span className="text-sm text-mp-gray/80 md:text-[15px]" data-id="element-224" data-mp="qudbr3w6vzse">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: easeOut,
          delay: 0.05
        }} className="rounded-2xl border border-mp-lime/50 bg-mp-card p-7 shadow-glow-lime md:p-9" data-id="element-225" data-mp="gya81tlovt3c">
            <p className="font-heading text-lg uppercase tracking-wide text-mp-white sm:text-xl" data-id="element-226" data-mp="3tg1ni69fwiim">Con el Kit</p>
            <ul className="mt-6 space-y-3" data-id="element-227" data-mp="28p2fg5frkxf">
              {conKit.map(item => <CheckItem key={item} data-id="element-228" data-mp="3kiiuofpk0zw6">{item}</CheckItem>)}
            </ul>
          </motion.div>
        </div>

        <p className="mt-12 text-center font-heading text-3xl uppercase text-mp-lime sm:text-4xl" data-id="element-229" data-mp="gzxya6zxm2j0">
          Por solo 6€ más.
        </p>
      </Container>
    </section>;
}